import {React, useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import emailjs from '@emailjs/browser';

import close_icon from '../images/close_icon.png'

function Form (props){
    // ModalToggle
    const showModal = props.open
    const close = props.close
    const number = props.number;

    if(showModal === true){
        document.body.style.overflowY="hidden";
    } else {document.body.style.overflowY="scroll";}

    const Navigate = useNavigate();


    const enquiry = useRef();
    const intialValues = {
        client_name: "",
        phone: "",
        email: "",
        service: "",
        requirements:"",
    };
    const [formValues, setFormValues] = useState(intialValues);
    const [formErrors, setFormErrors] = useState({})
    const [isSubmit, setIsSubmit] = useState(false);

    const handleChange = (e) => {
        console.log(e.target);
        const {name , value} = e.target;
        setFormValues({...formValues, [name]:value})
        console.log(formValues.service);
    }
    const handleSubmit = (e) =>{
        e.preventDefault();
        setFormErrors(validate(formValues));
        if(Object.keys(formErrors).length === 0) {
            setIsSubmit(true);
        }
        if(isSubmit){
            sendEmail();
            console.log("Mail_Sent")
            setTimeout ( () => {
                Navigate("/thank-you");
                setFormValues(intialValues);  //workaround for "form.reset();"
                close();
            },1000)
            
        };
        


    };
    const sendEmail = () =>{
     //template: template_sw0lram
    //service: service_6ynxdw4
    //public: hhvaZ8tXKLqxY8JXM
     
        emailjs
        .sendForm("service_6ynxdw4", "template_sw0lram", enquiry.current, "hhvaZ8tXKLqxY8JXM")
            .then(() => {
                // alert('Message Sent Successfully')
            }, (error) => {
                console.log(error.text);
                console.log("Something went wrong")
            });
    }


    useEffect(() => {
        // console.log(formErrors);

        if(Object.keys(formErrors).length === 0 && isSubmit){
            console.log(formValues);
        }
    }, [formErrors]);

    const validate = (values) => {
        const errors = {};
        const regex =  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if(!values.client_name){
            errors.client_name = "Name is requried";
        }

        if(!values.phone){
            errors.phone = "Phone is requried";
        } else if(values.phone.length != "10"){
            errors.phone = "Please enter a valid phone number"
        }

        if(!values.email){
            errors.email = "E-Mail is requried";
        } else if(!regex.test(values.email)){
            errors.email = "This is not a valid email format.";
        };

        if(!values.service){
            errors.service = "Please select a service"
        }

        return errors;
        

    }
    
    

    return(
        <>

            <div className={showModal === true ? "fixed inset-0 flex justify-center items-center bg-black bg-opacity-30  backdrop-blur-sm  overscroll-contain z-50 ": "hidden"}>
                <div className="bg-white py-12 px-7 w-full h-[85%] sm:h-fit sm:my-12 absolute bottom-0 overflow-scroll  sm:w-[380px] sm:relative rounded-[12px] ">
                    
                    
                    <h1 className="font-[merriweather] text-brown text-center text-[30px] font-medium leading-[43.5px] tracking-[0.75px]"> ENQUIRY</h1>

                    <img className="absolute top-5 right-6 w-[25px] cursor-pointer" src={close_icon} alt="Close-Icon" onClick={close}  />
                    <form ref={enquiry} className="mt-9" onSubmit={handleSubmit}>
                            <div className="flex flex-col justify-center my-7">
                                <label className="modal-label">Name <span className="asterik">*</span></label>
                                <input 
                                    className="modal-input" 
                                    name="client_name" 
                                    type="text" 
                                    placeholder="John Doe"
                                    value = {formValues.client_name}
                                    onChange= {handleChange}
                                />
                                <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.client_name}</p>
                            </div>
                            

                            <div className="flex flex-col justify-center my-7">
                                <label className="modal-label">Mobile Number <span className="asterik">*</span></label>
                                <input 
                                    className="modal-input" 
                                    name="phone" 
                                    type="tel" 
                                    placeholder="98765-43210"
                                    value = {formValues.phone}
                                    onChange= {handleChange}
                                />
                                <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.phone}</p>
                            </div>

                            <div className="flex flex-col justify-center my-7">
                                <label className="modal-label">Email <span className="asterik">*</span></label>
                                <input 
                                    className="modal-input" 
                                    name="email" 
                                    type="email" 
                                    placeholder="yourname@gmail.com"
                                    value = {formValues.email}
                                    onChange= {handleChange}
                                    
                                />
                                <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.email}</p>
                            </div>

                            <div className={"flex flex-col justify-center my-7"}>
                                <label className="modal-label">Service? <span className="asterik">*</span></label>
                                <select className="modal-select" name ="service" onChange={handleChange} >
                                    <option selected disabled>-Please select one from below-</option>
                                    <option value="Buying Brokerage">Buying Brokerage</option>
                                    <option value="Selling Brokerage">Selling Brokerage</option>
                                    <option value="Rental Brokerage">Rental Brokerage</option>
                                    <option value="Liaison Services">Liaison Services</option>
                                    <option value="Registration Services">Registration Services</option>
                                </select>
                                <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.service}</p>
                            </div>

                            <div className="flex flex-col justify-center my-7">
                                <label className="modal-label">Your Requirement</label>
                                <textarea 
                                    className="modal-input" 
                                    name="requirements" 
                                    type="text" 
                                    placeholder="Share your requirements">
                                </textarea>
                            </div>

                        <button className="bg-yellow w-full p-3  font-[lato] text-14px ">{Object.keys(formErrors).length === 0 && isSubmit ? "Submitting...." : "Submit"}</button>
                    </form>


                </div>
            </div>

            


        </>
    )
}

export default Form;